import { SymbolSchema } from "slotworks/server/symbols/symbol-schema";
import { parseJSONMap } from "slotworks/utils/json-utils";
class SymbolModel {

    private symbolMap: Map<string, string>;

    public init(data: SymbolSchema) {
        this.symbolMap = parseJSONMap(data.symbols);
    }
    public convertSymbolToSlotworks(symbol: string) {
        return this.symbolMap.get(symbol);
    }

}
export default new SymbolModel();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/server/symbols/symbol-model.ts